import {Action} from '@ngrx/store';
import * as moment from 'moment';
import {BijbEvent} from '../../../models/bijb-event';

export class GetChatsAction implements Action {
  public static readonly type = 'GetChatsAction';

  constructor(public bijbEvent: BijbEvent, public horizon = moment()) {
  }

  public type = GetChatsAction.type;
}
